// Lekkie wykresy bez zewnętrznych zależności (CSS + SVG), spójne z tokenami motywu.

type BarDatum = { label: string; value: number };

export function BarChart({
  data,
  height = 150,
  accent = "var(--sun)",
  emptyLabel = "Brak danych w tym okresie"
}: {
  data: BarDatum[];
  height?: number;
  accent?: string;
  emptyLabel?: string;
}) {
  const max = Math.max(1, ...data.map((d) => d.value));
  const hasAny = data.some((d) => d.value > 0);

  if (!hasAny) {
    return <div className="crm-bars-empty" style={{ height }}>{emptyLabel}</div>;
  }

  return (
    <div className="crm-bars" style={{ height }}>
      {data.map((d, i) => {
        const pct = d.value > 0 ? Math.max(6, Math.round((d.value / max) * 100)) : 0;
        return (
          <div className="crm-bar-col" key={i} title={`${d.label}: ${d.value}`}>
            <div className="crm-bar-track">
              <div className="crm-bar" style={{ height: `${pct}%`, background: accent }}>
                {d.value > 0 && <span className="crm-bar-value">{d.value}</span>}
              </div>
            </div>
            <span className="crm-bar-label">{d.label}</span>
          </div>
        );
      })}
    </div>
  );
}

type Segment = { label: string; value: number; color: string };

export function DonutChart({
  segments,
  size = 172,
  thickness = 24,
  unit = "leadów"
}: {
  segments: Segment[];
  size?: number;
  thickness?: number;
  unit?: string;
}) {
  const total = segments.reduce((sum, s) => sum + s.value, 0);
  const radius = (size - thickness) / 2;
  const circumference = 2 * Math.PI * radius;
  let offset = 0;

  return (
    <div className="crm-donut-wrap">
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="crm-donut"
        role="img"
        aria-label={`Razem ${total} ${unit}`}
      >
        <g transform={`rotate(-90 ${size / 2} ${size / 2})`}>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="var(--border-soft)"
            strokeWidth={thickness}
          />
          {total > 0 &&
            segments.map((seg, i) => {
              const dash = (seg.value / total) * circumference;
              const node = (
                <circle
                  key={i}
                  cx={size / 2}
                  cy={size / 2}
                  r={radius}
                  fill="none"
                  stroke={seg.color}
                  strokeWidth={thickness}
                  strokeDasharray={`${dash} ${circumference - dash}`}
                  strokeDashoffset={-offset}
                />
              );
              offset += dash;
              return node;
            })}
        </g>
        <text x="50%" y="47%" textAnchor="middle" className="crm-donut-total">
          {total}
        </text>
        <text x="50%" y="61%" textAnchor="middle" className="crm-donut-sub">
          {unit}
        </text>
      </svg>
      <ul className="crm-legend">
        {segments.map((seg, i) => (
          <li key={i}>
            <span className="crm-legend-dot" style={{ background: seg.color }} />
            <span className="crm-legend-label">{seg.label}</span>
            <span className="crm-legend-value">{seg.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
